import React, { useEffect, useRef } from 'react';
import { Center, Modal, Text, util } from '@thecb/components';
import { useDispatch, useSelector } from 'react-redux';
import { initiatePayment } from '../checkout/Checkout.state';
import { MAGTEK_SWIPE_CARD_MODAL } from './Checkout';
import { useLocation, useNavigate } from 'react-router-dom';

export default function MagtekSwipeCardModal({ fields, modals, actions }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { serviceFeeForCurrentAmount, convenienceFee } = useSelector(
    (state) => state.checkout,
  );
  let payload = useRef('');

  const isMagtekSwipe = (str) => str.slice(0, 2) === '%B';

  const doneTyping = () => {
    if (isMagtekSwipe(payload.current)) {
      dispatch(
        initiatePayment({
          amount_given: Number(fields.amount.rawValue),
          payment_tender_type: 'card',
          full_track_data: payload.current,
          service_fee: serviceFeeForCurrentAmount,
          convenience_fee: convenienceFee,
          navigate,
          location,
        }),
      );
      actions.modals.checkoutModal.closeModal();
    }
    payload.current = '';
  };

  const detectKeyDown = (e) => {
    e.preventDefault();
    if (e.key !== 'Shift') {
      payload.current += e.key;
    }
  };

  const detectKeyUp = (e) => {
    e.preventDefault();
    if (e.key === 'Enter') {
      doneTyping();
    }
  };

  /* 
  In case we want to implement visual indicators within the modal that the card swipe will work.

  const onFocus = () => {};
  const onBlur = () => {};
  */

  useEffect(() => {
    if (modals.checkoutModal.modalIsOpen) {
      document.addEventListener('keydown', detectKeyDown);
      document.addEventListener('keyup', detectKeyUp);
      /*
      window.addEventListener('focus', onFocus);
      window.addEventListener('blur', onBlur);
      */
    }

    return () => {
      document.removeEventListener('keydown', detectKeyDown);
      document.removeEventListener('keyup', detectKeyUp);
      /*
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
      */
    };
  }, [modals.checkoutModal.modalIsOpen]);

  return (
    <Modal
      modalHeaderText="Swipe Card"
      defaultWrapper={false}
      onlyCloseButton={true}
      modalOpen={
        modals.checkoutModal.modalIsOpen &&
        modals.checkoutModal.modalId === MAGTEK_SWIPE_CARD_MODAL
      }
      hideModal={actions.modals.checkoutModal.closeModal}
      onExit={util.general.noop}
      closeButtonText="Cancel"
      modalBodyText={
        <Center intrinsic>
          <Text variant="p">Please swipe the card to continue.</Text>
        </Center>
      }
    />
  );
}
